import script from "./RoomAvailability.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomAvailability.vue?vue&type=script&setup=true&lang=js"

import "./RoomAvailability.vue?vue&type=style&index=0&id=fbccc1fa&lang=css"

const __exports__ = script;

export default __exports__